const arrayValidations = {
    length: <T>(array: T[]): number => array.length,
};
export default arrayValidations;
